import React, { Component } from 'react';
import {Navbar, Col, Row} from 'react-bootstrap'
import PrivacyPolicy from './privacyPolicy';

class BottomNav extends Component {
    state = { 
        showPolicy: false
     }
     closePolicy=()=>{
        this.setState({showPolicy: false})
    }
    openPolicy=()=>{
       this.setState({showPolicy: true})
   }
    render() { 
        return (
            <div>
                <Navbar bg="dark" variant="dark" fixed='bottom'>
                    <Row style={{width: "100%"}}>
                        <Col xs='4'>
                        <p style={{color: 'white', margin: 'auto'}}>Copyright &copy; 2025 BreezeLabs CNCBreeze</p>

                        </Col>
                        <Col xs='4' style={{textAlign: 'center'}}>
                            <a alt='twitter' target='_blank' style={{marginRight: '5px'}} href='https://twitter.com/breezelabsuk'><img style={{width: '20px'}} src={require('../twitter.png')}></img></a>
                            <a alt='facebook' target='_blank' style={{marginLeft: '5px'}} href='https://facebook.com/BreezeLabs-100324582044806'><img style={{width: '20px'}} src={require('../facebook.png')}></img></a>
                        </Col>
                        <Col xs='4'>
                        <a style={{cursor: 'pointer', float: 'right'}} onClick={this.openPolicy}><p style={{color: 'white', margin: 'auto'}}>Privacy Policy</p></a>

                        </Col>
                    </Row>

                    <PrivacyPolicy showPolicy={this.state.showPolicy} closePolicy={this.closePolicy} openPolicy={this.openPolicy}/>      

                </Navbar>
            </div>
        );
    }
}

  
export default BottomNav;
